// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { ngxLoadingAnimationTypes } from 'ngx-loading';
import { SERVER_URL_GLOBAL } from './../serverUrl/serverUrl';
export const environment = {
  production: false,
  //SERVER_URL: 'http://www2.douane.gov.ma/rest/',
  SERVER_URL: SERVER_URL_GLOBAL,
  //SERVER_URL: 'http://localhost:8081/rest/',
  ITEMS_PER_PAGE: 10,

  LODING_CONFIG: {
    animationType: ngxLoadingAnimationTypes.circleSwish, primaryColour: '#ffffff',
    secondaryColour: '#ccc', tertiaryColour: '#ffffff', backdropBorderRadius: '3px', fullScreenBackdrop: true
  },
  MAX_SIZE_FILE_MO: 2,
  MAX_OTHER_DOC_UPLOAD_ALLOWED: 5,
  TYPE_FILES_ALLOWED: ['application/pdf'],
  TIMEOUT : 180000,
  VERSION :  '1.0.0',
  MOBILE_BREAK_POINT : 426
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
